import React, { useEffect } from 'react';
import moment from 'moment';
import CalendarNavBar from '../../components/CalendarControls/CalendarNavBar';
import CalendarControl from '../../components/CalendarControls/CalendarControl';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetExtraItems, actionResetExtraItems } from 'actions'
import { actionStartAppLoader, actionEndAppLoader } from '../../actions/actionAppLoader';
import { actionCalendarNavListView, actionCalendarNavCalendarView, actionCalendarHyridView } from 'actions';
import { genfunction } from '../../helpers';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import { actionGetDisplayAreasByType } from 'actions';
import { actionResetPaymentTransaction } from 'actions';
import { actionGetBookingTypes } from 'actions';
import { actionCalendarNavReset } from 'actions';
import CalendarListView from '../../components/CalendarControls/CalendarListView';
import CalendarHybridView from '../../components/CalendarControls/CalendarHybridView';
import { actionGetUserDefinedFields } from 'actions';
const { CalendarScreenHeading } = window['runConfig'];

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(5)
    }
  },
  content: {
    textAlign: "center"
  }

}));

const Calendar = (props) => {
  const constredirect = (products) => {
    props.history.push({
      pathname: '/checkout',
      products: products
    })
  }

  const dispatch = useDispatch();
  const classes = useStyles();

  const calendarNavState = useSelector(state => state.reducerCalendarView);
  const displayAreasState = useSelector(state => state.reducerDisplayAreas);
  const bookingTypes = useSelector(state => state.reducerBookingTypes);
  const events = useSelector(state => state.reducerShopCart.events);
  const paymenttranstate = useSelector(state => state.reducerPaymentTransaction.Payment);
  const bookingType = useSelector(state => state.reducerBookingTypes.bookingType);
  const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
  const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
  const giftcards = useSelector(state => state.reducerGiftCards);
  const bookingUDFS = useSelector(state => state.reducerBookingUserDefinedFields);
  const shopcartreducer = useSelector(state => state.reducerShopCart);
  const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

  useEffect(() => {
    if (events && events.length == 0 && membershipPackages && membershipPackages.length == 0 && gaTickets && gaTickets.length == 0 &&
      giftcards.giftcards && giftcards.giftcards.length == 0 && donationProducts && donationProducts.length == 0 && paymenttranstate.hasOwnProperty("ReceiptNo") && paymenttranstate.ReceiptNo.toString().length > 0) {
      actionResetPaymentTransaction(dispatch);
    }
  }, []);


  useEffect(() => {
    actionCalendarNavReset(dispatch);

    var id = props.match.params.id;
    if (props.match.path == "/calendar/:id") {
      actionGetBookingTypes(dispatch, id, false);

      if (shopcartreducer.managemybooking === false) { // && bookingUDFS.bookingUDFs.length < 1
        actionGetUserDefinedFields(dispatch, 'Booking', id, '');
      }

    }

    if (props.match.path == "/calendar/Area/:id") {
      actionGetDisplayAreasByType(dispatch, "bookingtypes", id, true);
      actionGetBookingTypes(dispatch, id, true);
    }

  }, []);


  useEffect(() => {
    if (props.match.path == "/calendar/Area/:id" && bookingTypes.bookingTypes.length > 0) {
      let bookingListOfIds = null;

      bookingTypes.bookingTypes.map(obj => {

        bookingListOfIds += obj.BookingTypeID;
        bookingListOfIds += ",";
      });

      if (bookingListOfIds.length > 0) {
        bookingListOfIds = bookingListOfIds.substr(0, bookingListOfIds.length - 1);
      }

      if (shopcartreducer.managemybooking === false) { // && bookingUDFS.bookingUDFs.length < 1
        actionGetUserDefinedFields(dispatch, 'Booking', '', bookingListOfIds.toString());
      }
    }
  }, [bookingTypes])

  useEffect(() => {

    if ((bookingTypes.bookingTypes && bookingTypes.bookingTypes.length > 0 && bookingTypes.loading === false) && (displayAreasState && displayAreasState.displayAreas && displayAreasState.displayAreas.length > 0)) {

      if (props.match.path == "/calendar/:id" && bookingTypes.bookingTypes.find(x => x.BookingTypeID === parseInt(props.match.params.id)) === undefined) {
        return;
      }

      adjustView();
    }
    else if (props.match.path == "/calendar/:id" && bookingTypes.bookingTypes && bookingTypes.bookingTypes.length > 0) {

      if (props.match.path == "/calendar/:id" && bookingTypes.bookingTypes.find(x => x.BookingTypeID === parseInt(props.match.params.id)) === undefined) {
        return;
      }

      adjustView();
    }
    else if (props.match.path == "/calendar/Area/:id" && displayAreasState && displayAreasState.displayAreas && displayAreasState.displayAreas.length > 0) {
      adjustView();
    }

  }, [bookingTypes.bookingTypes, displayAreasState.displayAreas])


  const CheckIsForceListView = () => {
    if (props.match.path == "/calendar/Area/:id" && displayAreasState
      && displayAreasState.displayAreas
      && displayAreasState.displayAreas.length > 0) {
      let displayArea = displayAreasState.displayAreas.find(x => x.DisplayAreaNo == props.match.params.id);
      if (displayArea) {
        if (displayArea.ForceListView) {
          return true;
        }
        else {
          return false;
        }
      }
    }
    else if (props.match.path == "/calendar/:id" && bookingTypes.bookingTypes != undefined && bookingTypes.bookingTypes.length > 0) {
      var bkngTyp = bookingTypes.bookingTypes.find(x => x.BookingTypeID === parseInt(props.match.params.id));
      if (bkngTyp) {
        return bkngTyp.ForceListView;
      }

      // return bookingTypes.bookingTypes[0].ForceListView;
    }
    else {
      return false;
    }
  }

  const CheckIsDefaultHybridView = () => {
    if (props.match.path == "/calendar/Area/:id" && displayAreasState
      && displayAreasState.displayAreas
      && displayAreasState.displayAreas.length > 0) {
      let displayArea = displayAreasState.displayAreas.find(x => x.DisplayAreaNo == props.match.params.id);
      if (displayArea) {
        if (displayArea.DefaultHybridView) {
          return true;
        }
        else {
          return false;
        }
      }
    }
    else if (props.match.path == "/calendar/:id" && bookingTypes.bookingTypes != undefined && bookingTypes.bookingTypes.length > 0) {
      var bkngTyp = bookingTypes.bookingTypes.find(x => x.BookingTypeID === parseInt(props.match.params.id));
      if (bkngTyp) {
        return bkngTyp.DefaultHybridView;
      }
    }
    else {
      return false;
    }
  }

  const adjustView = () => {
    if (CheckIsDefaultHybridView()) {
      actionCalendarHyridView(dispatch);
    }
    else if (CheckIsForceListView()) {
      actionCalendarNavListView(dispatch);
    }
    else {
      if (calendarNavState.viewType === "") {
        if (window.innerWidth < 850) {
          actionCalendarNavListView(dispatch);
        }
        else {
          actionCalendarNavCalendarView(dispatch);
        }
      }
    }
  }

  useEffect(() => {
    if (extramItemsstate.loading === true || bookingUDFS.loading === true) {
      actionStartAppLoader(dispatch);
    }
    else {
      actionEndAppLoader(dispatch);
    }
  })

  const GetFilterDates = (fromDate) => {

    var Id = props.match.params.id;
    var showDisplay = false;
    let bookingType = {};
    let displayArea = {};

    if (props.match.path == "/calendar/Area/:id") {
      showDisplay = true;
      displayArea = displayAreasState.displayAreas.length > 0 ? displayAreasState.displayAreas.find(x => x.DisplayAreaNo == Id) : undefined;
    }
    else {

      bookingType = bookingTypes.bookingTypes.find(x => x.BookingTypeID == Id);

      if (bookingType !== undefined &&
        bookingType.hasOwnProperty('NextTourDate') && bookingType.NextTourDate.length > 0) {
        if (moment(genfunction.AddToDateDate(fromDate)).format('YYYY-MM-DD') <
          moment(bookingType.NextTourDate).format('YYYY-MM-DD')) {
          actionResetExtraItems(dispatch);
          return;
        }
      }
    }

    if (bookingType !== undefined) {
      actionGetExtraItems(dispatch, Id, true, showDisplay, fromDate, true);
    }
  }

  const extramItemsstate = useSelector(state => state.reducerExtraItems);

  return (
    <div id={"vt_page_tour"} className={classes.root}>
      {calendarNavState.viewType !== "" && calendarNavState.viewType !== "HybridView" ?
        <>
          <div className={classes.content}>
            <Typography variant="h1" component="h1" color="primary">{CalendarScreenHeading}</Typography>
          </div>
          <CalendarNavBar Path={props.match.path} bookingType={bookingType} urlID={props.match.params.id} />
        </>
        : ""}
      {calendarNavState.viewType !== "" && calendarNavState.viewType === "CalendarView" ? <CalendarControl tourEvents={extramItemsstate.extramItems} Path={props.match.path} urlID={props.match.params.id} constredirect={constredirect} /> : null}
      {calendarNavState.viewType !== "" && calendarNavState.viewType === "ListView" ? <CalendarListView tourEvents={extramItemsstate.extramItems} Path={props.match.path} urlID={props.match.params.id} constredirect={constredirect} onFilter={GetFilterDates} ></CalendarListView> : null}
      {calendarNavState.viewType !== "" && calendarNavState.viewType === "HybridView" ? <CalendarHybridView tourEvents={extramItemsstate.extramItems} Path={props.match.path} urlID={props.match.params.id} constredirect={constredirect} onFilter={GetFilterDates} /> : null}
    </div>
  );
}

export default Calendar;
